import "./App.css";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import { useState, useEffect } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FaRegCircleCheck } from "react-icons/fa6";
import { CiHeart } from "react-icons/ci";
import { FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { FaLine } from "react-icons/fa";

function App() {
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    const updateBackground = () => {
      if (window.innerWidth >= 1024) {
        setBgImage("");
      } else {
        setBgImage("url('/Mask.png')");
      }
    };

    updateBackground();
    window.addEventListener("resize", updateBackground);

    return () => window.removeEventListener("resize", updateBackground);
  }, []);
  return (
    <div className="bg-tonelight1">
      {/* NAVBAR */}

      <nav className="flex items-center justify-around">
        <div className="flex items-center gap-2 text-xl m-1">
          {/* <img
            src="/logo2 (2).png"
            alt="Description of image"
            className="w-12 animate-spin-slow"
          /> */}
          <h1 className="font-bold kanit-medium">The One Math Academy</h1>
        </div>
        {/* <div className="justify-items-center bg-white p-4 rounded-3xl bg-opacity-25 hidden sm:block">
          <h5 className="kanit-medium">
            คอร์สคณิตศาสตร์สำหรับเตรียมสอบคณิต A-Level 1
          </h5>
          <h5 className="kanit-medium">สอนโดย อิงฟ้า อัญทิชา</h5>
        </div>
        <a
          href="#"
          className="kanit-medium text-white bg-tonedark2 pt-2 pb-2 pr-4 pl-4 rounded-lg text-xl hidden sm:block"
        >
          สมัครเรียน
        </a> */}
      </nav>

      {/* MASK IMAGE */}
      {/* <img src="/Mask.png" alt="Description of image" className="fixed top-0 left-1/2 sm:w-full md:w-5/6 transform -translate-x-1/2 object-contain z-[-1] mt-12 md:m-0" /> */}

      {/* LABEL SECTION */}
      <div
        className="h-full flex flex-col justify-center items-center relative bg-cover bg-center py-12 px-4 bg-white lg:border-y-2 lg:border-y-black"
        style={{ backgroundImage: bgImage, backgroundPosition: "center top" }}
      >
        <h1 className="font-bold text-3xl md:text-6xl  text-center kanit-semibold mb-3">
          ช่วยให้น้อง
        </h1>
        <h1 className="font-bold text-3xl md:text-6xl text-center kanit-bold mb-3">
          ได้คะแนนคณิตเอเลเวลสูง
        </h1>
        {/* <h1 className='font-bold text-2xl sm:text-base md:text-7xl text-center kanit-bold mb-4 md:mb-20'>อนิเมชันคณิตศาสตร์</h1> */}
        <h1 className="font-semibold text-3xl md:text-6xl text-center kanit-semibold mb-3">
          ผ่านการฝึกโจทย์ที่ตรงจุด
        </h1>
        <div className="text-center my-10 text-base md:text-xl">
          <p>คอร์สที่จะช่วยให้น้องติดมหาลัยที่หวัง</p>
          <p>และทำคะแนนคณิตได้สูง</p>
          <p>จากการเรียนและฝึกโจทย์ที่เข้าเป้า</p>
        </div>
        <p className="font-semibold text-2xl md:text-2xl text-center kanit-semibold underline">
          MATH Alevel 1 + alevelGPT
        </p>
        {/* <div className="w-full max-w-[800px] mx-auto">
          <div className="aspect-video mt-3 rounded-md overflow-hidden">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/CynCjDN8V98"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div> */}
        <div className="flex max-md:flex-col-reverse gap-2 pt-4">
          <div className=" w-full flex justify-center">
            <a
              href="https://linktr.ee/freecourseset"
              target="_blank"
              className="kanit-medium text-black bg-white border border-black pt-2 pb-2 pr-4 pl-4 rounded-lg text-lg md:text-2xl whitespace-nowrap"
            >
              ทดลองเรียน
            </a>
          </div>
          <div className=" w-full flex justify-center">
            <a
              href="https://lin.ee/ZgV1E16"
              target="_blank"
              className="kanit-medium text-white bg-green-400 pt-2 pb-2 pr-4 pl-4 rounded-lg text-lg md:text-2xl flex items-center gap-2"
            >
              <FaLine />
              <p className="whitespace-nowrap">สมัครเรียน</p>
            </a>
          </div>
        </div>
        <p>**ราคาเปิดตัว จะหมดเขตเร็วๆนี้</p>
      </div>
      <div className="text-center mt-10 mx-a text-base md:text-xl">
        <p className="kanit-semibold">ผลลัพธ์จริงจากประสบการณ์ของพี่โดยตรง</p>
        <div className="my-4">
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>พี่เป็นเด็กสามจังหวัดชายแดนใต้</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>พี่ไม่คิดว่าตัวเองจะสอบเข้ามอดังได้เลยด้วยซ้ำ</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>พี่ลองผิดลองถูกกับการทำโจทย์มามากมาย</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>เคยอยู่ในจุดที่ทำโจทย์เองไม่ได้เลย</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>จนสุดท้าย....พี่ก็เจอทางที่ถูกต้อง</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>จนพี่สอบติดคณะบัญชี ธรรมศาสตร์</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>ซึ่งคณะนี้ใช้ % คะแนนคณิตสูงมาก</p>
          </div>
          <div className="flex justify-center items-center gap-2 ">
            {/* <div className="bg-black h-1 w-1 rounded-full"></div> */}
            <p>น้องไม่จำเป็นต้องไปลองผิดลองถูกเอง</p>
          </div>
        </div>
        <p>พี่เอาประสบการณ์ทั้งหมดมารวมไว้ในคอร์สนี้แล้ว</p>
      </div>
      {/* คอร์สนี้ได้อะไรบ้าง */}
      <div>
        <h1 className="text-center m-5 mt-10 text-3xl kanit-semibold">
          คอร์สนี้ได้อะไรบ้าง ?
        </h1>
        <div className="relative bg-cover bg-center">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 max-w-[1200px] mx-auto">
            {/* CARD */}
            <div className="justify-items-center bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div className="flex items-center justify-center gap-2">
                <img src="/Frame (1).png" alt="Description1" className="w-7" />
                <h2 className="kanit-semibold text-xl">ปรับพื้นฐานก่อนเรียน</h2>
              </div>
              <p className="kanit-regular md:text-lg mt-2">
                ถ้าน้องพื้นฐานน้อยกลัวเรียนไม่รู้เรื่อง ไม่ต้องกังวล
                พี่แก้พื้นฐานใหม่ให้หมด ตาม 13 บทที่คัดมาแล้วว่าต่อยอดได้ทุกบท
                เรียนตั้งแต่พื้นฐานการคำนวณ ไปจนถึงการแก้สมการที่ซับซ้อน
              </p>
              <img src="image 25.png" className="mt-4" />
            </div>
            <div className="justify-items-center flex flex-col bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div>
                <div className="flex items-center justify-center gap-2">
                  <img
                    src="/Frame (5).png"
                    alt="Description1"
                    className="w-7"
                  />
                  <h2 className="kanit-semibold text-xl">
                    เรียนได้จนกว่าจะสอบติด
                  </h2>
                </div>
                <p className="kanit-regular md:text-lg mt-2">
                  ไม่มีอายุคอร์ส พี่จะส่งฟอร์มให้ยืนยันตัวตนทุกๆ 6 เดือน
                  เช่นถ้าตอนนี้อยู่ม.4 ก็สามารถอยู่ในคอร์สได้จบจนม.6 เลยย
                  ถ้าอยู่ ม.4 หรือ ม.5
                  ก็สามารถสมัครเข้ามาเรียนเนื้อหาเพื่อเก็บเกรดที่โรงเรียนได้
                  แถมยังได้เตรียมสอบเข้ามหาลัยไปด้วย เรียนซ้ำกี่รอบก็ได้
                  ไม่จำกัด
                </p>
              </div>
              <img src="image 21.png" className="m-auto" />
            </div>
            <div className="justify-items-center flex flex-col bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div>
                <div className="flex items-center justify-center gap-2">
                  <img
                    src="/Frame (5).png"
                    alt="Description1"
                    className="w-7"
                  />
                  <h2 className="kanit-semibold text-xl">เอกสารการสอน(PDF)</h2>
                </div>
                <p className="kanit-regular md:text-lg mt-2">
                  ได้รับเอกสารครบทั้งปรับพื้นฐาน เนื้อหาคณิตศาสตร์ ม.ปลายทั้งหมด
                  ซึ่งจะมีการบ้านให้ฝึกทำ และ
                  ตะลุยโจทย์แยกบทและรวมบทตามข้อสอบแนวคณิตศาสตร์ประยุกต์ 1
                  โดยเฉพาะ
                </p>
              </div>
              <img src="image copy.png" className="m-auto" />
            </div>
            <div className="justify-items-center bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div className="flex items-center justify-center gap-2">
                <img src="/Frame (3).png" alt="Description1" className="w-7" />
                <h2 className="kanit-semibold text-xl">
                  ตะลุยโจทย์ข้อสอบเก่า A-Level 1
                </h2>
              </div>
              <p className="kanit-regular md:text-lg mt-2">
                สอนเทคนิคการแก้โจทย์รูปแบบที่เหมาะสมสำหรับโจทย์แต่ละข้อ
                เพื่อให้น้องทำโจทย์ได้แม่นยำและรวดเร็วที่สุด
                นอกจากข้อสอบเก่าแล้ว พี่ได้สร้างโจทย์แนวคณิตศาสตร์ประยุกต์ 1
                โดยเฉพาะ มาให้น้องๆฝึก
                น้องไม่ต้องไปเสียเวลาทำข้อสอบที่ไม่ตรงแพทเทิลข้อสอบจริงเป็นหลายพันข้อ
                ฝึกถูกจุดจะทำให้น้องได้คะแนนสูงในเวลาที่รวดเร็ว
              </p>
            </div>
            <div className="justify-items-center bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div className="flex items-center justify-center gap-2">
                <img src="/Frame (2).png" alt="Description1" className="w-7" />
                <h2 className="kanit-semibold text-xl">
                  เรียนเนื้อหาม.ปลายครบ 15 บท
                </h2>
              </div>
              <p className="kanit-regular md:text-lg mt-2">
                เรียนตั้งแต่เนื้อหาพื้นฐาน ไปจนถึง ตะลุยโจทย์รายบท
                เรียนที่โรงเรียนไม่เข้าใจ ไม่ต้องกังวล พี่สอนใหม่หมด
                พี่เรียบเรียงเนื้อหาเพื่อให้น้องทำโจทย์คณิต 1 ได้ในที่สุด
                พี่คัดโจทย์จากข้อสอบเก่ามาสอนเพิ่ม คัดมาแล้วว่า ถ้าฝึกตามนี้
                คะแนนสอบคณิต 1 พุ่งสูงแน่นอน นอกจากนี้ยังมี Demo
                เรื่องกราฟกันสดๆในห้องเรียง
              </p>
            </div>
            <div className="justify-items-center bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div className="flex items-center justify-center gap-2">
                <img src="/Frame.png" alt="Description1" className="w-7" />
                <h2 className="kanit-semibold text-xl">
                  ปรึกษาได้ตลอดการเรียน
                </h2>
              </div>
              <p className="kanit-regular md:text-lg mt-2">
              ทำโจทย์ไม่เป็น เริ่มต้นไม่ถูก กังวลเรื่องการวางแผนเข้ามหาลัย ปรึกษาได้ตลอด พี่จะทำให้น้องไปต่อได้เอง "อยู่ข้างๆจนกว่าจะสอบติด"
              </p>
            </div>
            <div className="justify-items-center bg-white p-4 rounded-3xl bg-opacity-60 m-4">
              <div className="flex items-center justify-center gap-2">
                <img src="/Frame (2).png" alt="Description1" className="w-7" />
                <h2 className="kanit-semibold text-xl">A-Level GPT</h2>
              </div>
              <p className="kanit-regular md:text-lg mt-2">
                ตัวช่วยน้องในการเตรียมตัวสอบ A-Level คณิตโดยเฉพาะ จะช่วยสอนน้อง
                นำทางน้องในการทำโจทย์ พี่เทรนด์ AI ตัวนี้เอง ดังนั้น AI
                ตัวนี้ตอบโจทย์ในการช่วยเหลือน้องตลอดการเตรียมตัวสอบ
                รวมถึงช่วยสอนการบ้านที่โรงเรียนอีกด้วย
              </p>
              <img src="Alevel.png" className="mt-4" />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <a
          href="https://lin.ee/ZgV1E16"
          target="_blank"
          className="kanit-medium text-white bg-green-400 pt-2 pb-2 pr-4 pl-4 rounded-lg text-lg md:text-2xl flex items-center gap-2"
        >
          <FaLine />
          <p className="whitespace-nowrap">สมัครเรียน</p>
        </a>
        <p>**ราคาเปิดตัว จะหมดเขตเร็วๆนี้</p>
      </div>

      <style jsx>{`
        /* เพิ่มแอนิเมชันสำหรับพื้นหลัง */
        @keyframes rotateBackground {
          0% {
            background-position: center top;
          }
          100% {
            background-position: 100% 100%;
          }
        }

        .bg-animate {
          animation: rotateBackground 30s infinite linear;
        }
      `}</style>
      {/* ผู้สอน */}
      <div>
        <h1 className="text-center m-5 mt-10 text-3xl kanit-semibold">
          ผู้สอน อิงฟ้า อัญทิชา
        </h1>
        <div className="block lg:flex justify-center mx-auto max-w-[1200px]">
          <img
            src="/Profile_image 1.png"
            alt="Description of image"
            className="w-full max-w-[400px] aspect-[3/4] object-cover border-spacing-2 border-green-100 mb-4 lg:mb-0 mx-auto lg:mx-0 lg:mr-4 rounded-lg px-4 md:-px-0"
          />
          <div className="bg-white p-4 rounded-3xl bg-opacity-60">
            <div className="text-center">
              <h1 className="kanit-semibold text-xl">ประสบการณ์สอน</h1>
            </div>
            <div className="flex justify-center bg-tonelight1 w-full max-w-[550px] p-4 mx-auto rounded-md">
              <ul className="list-disc list-inside text-center space-y-4 md:text-lg">
                <li>สอนนักศึกษาคณะคณิตศาสตร์ประกันภัย มหาลัยวิทยาลัยมหิดล</li>
                <li>สอนนักเรียนมัธยมศึกษา ม.ปลาย</li>
              </ul>
            </div>
            <br></br>
            <div>
              <h1 className="kanit-semibold text-xl text-center">
                ประวัติผู้สอน
              </h1>
              <div className="flex justify-center bg-tonelight1 w-full max-w-[550px] p-4 mx-auto rounded-md">
                <div>
                  <ul className="list-disc list-inside text-center space-y-4 md:text-lg">
                    <li>
                      จบการศึกษา คณะเทคโนโลยีสารสนเทศ แขนงวิศกรรมซอฟแวร์
                      ลาดกระบัง (เกียรตินิยม)
                    </li>
                    <li>รางวัลเหรียญทองฟิสิกส์สัปประยุทธ์</li>
                    <li>สอบติดคณะบัญชีธรรมศาสตร์</li>
                    <li>
                      รางวัลรองชนะเลิศอันดับ 1
                      แข่งขันด้วยโปรเจคการทดสอบประสิทธิภาพ
                      ของระบบซื้อขายพันธบัตร ของธนาคารกสิกรไทย
                    </li>
                    <li>
                      ปัจจุบันทำงานในตำแหน่ง Application Developer at Land and House Bank
                    </li>
                    <li>
                      มีติวเตอร์ที่มีประสบการณ์กว่า 3 ปี มาร่วมสอนในคอร์ส
                    </li>
                  </ul>
                  <div className="grid grid-cols-4 gap-4 px-4 mx-auto mt-4">
                    <img
                      src="it-kmitl.png"
                      className="w-full h-auto object-cover"
                      alt="Image 1"
                    />
                    <img
                      src="image.png"
                      className="w-full h-auto object-cover"
                      alt="Image 2"
                    />
                    <img
                      src="logo01.png"
                      className="w-full h-auto object-cover"
                      alt="Image 3"
                    />
                    <img
                      src="0.png"
                      className="w-full h-auto object-cover"
                      alt="Image 4"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center mt-4">
          <a
            href="https://lin.ee/ZgV1E16"
            target="_blank"
            className="kanit-medium text-white bg-green-400 pt-2 pb-2 pr-4 pl-4 rounded-lg text-lg md:text-2xl flex items-center gap-2"
          >
            <FaLine />
            <p className="whitespace-nowrap">สมัครเรียน</p>
          </a>
          <p>**ราคาเปิดตัว จะหมดเขตเร็วๆนี้</p>
        </div>
      </div>
      {/* ขอบคุณความคิดเห็นจากน้องๆและพี่ๆ */}
      {/* <div> */}
      <h2 className="text-center m-5 mt-10 text-3xl kanit-semibold">
        ความคิดเห็นการสอน
      </h2>
      {/* <img src="/image 3.png" alt="Description of image" className='w-10/12 rounded-lg m-auto'/> */}
      {/* <img src="/image 3.png" alt="Description of image" className='w-10/12 rounded-lg m-auto'/> */}
      <div className="grid md:grid-cols-2 gap-4 px-4 mx-auto max-w-[1200px]">
        <img
          src="IMG_5778.png"
          className="w-full h-auto object-cover"
          alt="Image 4"
        />
        <img
          src="IMG_5779.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_5782.png"
          className="w-full h-auto object-cover"
          alt="Image 4"
        />
        <img
          src="IMG_5781.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_2941.jpg"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4909.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4913.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4912.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4911.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4910.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4908.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4914.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
        <img
          src="IMG_4907.png"
          className="w-full h-auto object-cover my-auto"
          alt="Image 4"
        />
      </div>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 800,
          disableOnInteraction: false,
        }}
        pagination={{
          el: ".custom-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} w-2 h-2 rounded-full bg-gray-300 inline-block mx-1 transition-all duration-300"></span>`;
          },
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper max-w-[1200px] mt-4 !px-4"
        breakpoints={{
          1280: { slidesPerView: 4 },
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
      >
        {[
          "/image 5.png",
          "/image 6.png",
          "/image 7.png",
          "/image 8.png",
          "/image 9.png",
          "/image 10.png",
        ].map((src, idx) => (
          <SwiperSlide key={idx}>
            <img
              src={src}
              alt={`Slide ${idx + 1}`}
              className="w-full h-auto object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="custom-pagination mt-4 flex justify-center items-center" />

      {/* สมัครคอร์สเรียน */}
      <div className="px-2">
        <h1 className="text-center m-5 mt-10 text-3xl kanit-semibold">
          สมัครคอร์สเรียน
        </h1>
        <div className="bg-white w-full max-w-[550px] p-4 mx-auto rounded-md md:text-lg">
          <p className="font-semibold text-xl">
            ถ้าน้องจริงจัง อยากเป็นคนหนึ่งที่ต้นทุนความรู้น้อย
            แต่สอบติดมหาลัยดัง
          </p>
          <p className="my-4">
            ให้พี่ช่วยน้อง เพราะพี่เริ่มจากเป็นเด็กโรงเรียนในสามจังหวัดชายแดนใต้
            จนสอบติดมหาลัยชื่อดังที่ได้ขึ้นชื่อว่าเข้ายาก พี่เข้าใจน้องที่สุด
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>เรียนได้จนกว่าจะสอบติด</p>
            </div>
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>ปรึกษาได้ตลอดเวลาเรียน</p>
            </div>
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>ตะลุยโจทย์คณิตศาสตร์ A-Level 1</p>
            </div>
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>การบ้านท้ายบท</p>
            </div>
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>เรียนเนื้อหาครบทุกบทม.ปลาย</p>
            </div>
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>ปรับพื้นฐานก่อนเรียน ด้วย 13 บทสำคัญ</p>
            </div>
            <div className="flex items-center gap-2">
              <FaRegCircleCheck />
              <p>แถม! alevelGPT</p>
            </div>
            <p>ผู้ช่วยสำหรับน้องที่จะเตรียมสอบคณิตศาสตร์ alevel โดยเฉพาะ</p>
          </div>

          <div className="md:flex justify-between gap-4 mt-4">
            {/* <p className="text-3xl kanit-semibold bg-tonelight1 p-4 rounded-md self-center text-center">
              4500.-
            </p> */}
            <div className="font-semibold text-xl mt-4 md:mt-0 w-full">
              <p className="text-center">
                นี่คือโอกาสที่น้อง ๆ จะได้คะแนนคณิตสูง
              </p>
              <a
                href="https://lin.ee/ZgV1E16"
                target="_blank"
                className="kanit-medium text-white bg-green-400 pt-2 pb-2 pr-4 pl-4 rounded-lg text-lg md:text-2xl flex items-center justify-center gap-2"
              >
                <FaLine />
                <p className="whitespace-nowrap">สมัครเรียน</p>
              </a>
              {/* <p className="text-sm kanit-semibold bg-tonelight1 p-1 rounded-md self-center text-center">
                **ราคาเปิดตัว จะหมดเขตเร็วๆนี้
              </p> */}
            </div>
          </div>
        </div>
      </div>

      {/* footer */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-white rounded-md p-4 w-full mt-10 gap-4">
        {/* ซ้าย (บนมือถือจะอยู่บนสุดตรงกลาง) */}
        <p className="font-semibold text-xl text-center md:text-left md:w-auto md:flex-1">
          The One Math Academy
        </p>

        {/* กลาง */}
        <div className="flex gap-4 items-center text-[#8987A1] justify-center md:justify-center md:w-auto md:flex-1 relative">
          <CiHeart />
          <p>INGFAH ANTHICHA</p>
        </div>

        {/* ขวา */}
        <div className="flex gap-4 justify-center md:justify-end md:flex-1">
          <a
            href="https://www.instagram.com/ingfah_anthicha/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="text-2xl hover:text-pink-500 transition-colors duration-300" />
          </a>
          <a
            href="https://www.tiktok.com/@ingfah_anthicha"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok className="text-2xl hover:text-[#25F4EE] transition-colors duration-300" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
